// extracted by mini-css-extract-plugin
export var infoItem = "_p9-2";
export var title = "_p9-0";
export var value = "_p9-1";